import { makeBillDetailDataByName } from '../../../redux/selectors/billDetail';
import { cartContentQuantitySelector } from '../../../redux/selectors/cartContentSelector';
import { getCurrentSubmitBillDataByName } from '../../../redux/selectors/transactionDetail';
import { makeDefaultCurrencyData } from '../../../redux/selectors/VBConfigSelector';
import { useSelector } from '../../../redux/utils';

export const useData = () => {
  const totalQuantity = useSelector(cartContentQuantitySelector());
  const totalPrice = useSelector(makeBillDetailDataByName('total_price'));
  const { symbol } = useSelector(makeDefaultCurrencyData());
  const useVcoin = useSelector(makeBillDetailDataByName('use_vcoin'));
  const coupon = useSelector(makeBillDetailDataByName('coupon'));
  const selectedMethod = useSelector(
    getCurrentSubmitBillDataByName('delivery_mode')
  );
  const hasDiscount = useVcoin > 0 || coupon?.coupon_value > 0;

  return {
    totalQuantity,
    totalPrice,
    symbol,
    hasDiscount,
    selectedMethod,
  };
};
